import { render, staticRenderFns } from "./ModificarOrden.vue?vue&type=template&id=1f345286&scoped=true&"
import script from "./ModificarOrden.vue?vue&type=script&lang=js&"
export * from "./ModificarOrden.vue?vue&type=script&lang=js&"
import style0 from "./ModificarOrden.vue?vue&type=style&index=0&id=1f345286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f345286",
  null
  
)

export default component.exports